import React, { useEffect, useState } from "react";
import Layout from "../Componants/Layout";
import { Button, Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useFormik } from "formik";
import GetAddressInfo from "../hooks/GetAddressInfo";
import { CustomerAccountValidationSchema } from "../utils/Validations";
import { useMutation } from "@tanstack/react-query";
import { putRequest } from "../services/apiMethods";
import useVendorDetails from "../hooks/VendorDetails";
import useImageUploader from "../hooks/UploadImage";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import toast from "react-hot-toast";
import Spinner from 'react-bootstrap/Spinner';
import EmailverifyModal from "../Modal/EmailverifyModal";
import ConfirmModal from "../Modal/ConfirmModal";
import { useLocation } from "react-router-dom";
import ConfirmPassword from "../Modal/ConfirmPassword";
import CustomerUpdatePassword from "../Componants/CustomerUpdatePassword";


export default function CustomerAccount() {
  const { data: CustomerProfileData, refresh } = useVendorDetails();
  const location = useLocation();
  const [phone, setPhone] = useState("");
  const { uploadImage, loading, error, uploadedUrl, errorMessage } = useImageUploader();  // Call the hook here
  const { addressData, getAddress } = GetAddressInfo();
  const [updatedEmail, setUpdatedEmail] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [selectedType, setSelectedType] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [passwordshow, setPasswordshow] = useState(false);

  const handlePasswordConfirm = (type) => {
    setPasswordshow(true);
    setSelectedType(type);
  };

  const handlePasswordClose = async () => {
    setPasswordshow(false);
  };


  const handleDelete = (type) => {
    setModalOpen(true);
    setSelectedType(type);
  };

  const handleConfirmClose = async () => {
    setModalOpen(false);
  };


  const handleSearchClick = (postCode) => {
    if (postCode) {
      getAddress(postCode);
    }
  };

  const initialdata = {
    name: "",
    postCode: "",
    address: "",
    phoneNumber: "",
    countryCode: "",
    email: "",
    latitude: addressData?.latitude || 0,
    longitude: addressData?.longitude || 0,
    image: null,
    marketingSparkPro: {
      emailNotification: false,
      pushNotification: false,
    },
    electrianRespond: {
      emailNotification: false,
      pushNotification: false,
    },
  }
  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      const modifyData = {
        id: data?._id,
        role: "Customer",
        name: data?.name,
        postCode: data?.postCode,
        address: data?.address,
        phoneNumber: data?.phoneNumber,
        countryCode: data?.countryCode,
        latitude: addressData?.latitude || 0,
        longitude: addressData?.longitude || 0,
        email: data?.email,
        image: (data?.image) || (uploadedUrl ? uploadedUrl : ""),
        marketingSparkPro: {
          emailNotification: data?.marketingSparkPro?.emailNotification,
          pushNotification: data?.marketingSparkPro?.pushNotification,
        },
        electrianRespond: {
          emailNotification: data?.electrianRespond?.emailNotification,
          pushNotification: data?.electrianRespond?.pushNotification,
        }
      };
      return putRequest(`/profile/edit`, modifyData);
    },
    onSuccess: (data) => {
      if (data?.data?.updatedEmail && data?.data?.updatedEmail !== CustomerProfileData?.email) {
        handleShow()
        setUpdatedEmail(data?.data?.updatedEmail)
      } else {
        toast.success(`${data?.message}`, {
          iconTheme: {
            primary: '#337FE0',
            secondary: '#FFFAEE',
          },
        })
        refresh()
      }

    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  const formik = useFormik({
    initialValues: CustomerProfileData || initialdata,
    enableReinitialize: true,
    validationSchema: CustomerAccountValidationSchema,
    onSubmit: (values) => {
      console.log("Form data:", values);
      mutate(values);
    },
  });


  useEffect(() => {
    if (CustomerProfileData?.postCode) {
      getAddress(CustomerProfileData?.postCode);  // Trigger the getAddress function with the initial postCode
    }
  }, [CustomerProfileData?.postCode]); // Only re-run when postCode changes


  return (
    <Layout>
      <Container>
        <div className="dashboard-main">
          <h3>Account</h3>
          <p>Configure your details and settings for your account</p>
          <Row>
            <Col lg={8}>
              <div className="my-profile-card-contain">
                <div className="my-profile-box-contain">
                  <div className="my-profile-box-form">
                    <div className="h-100 m-0">
                      <div className="form-box-title">
                        <h4>My Details</h4>
                        <p>Profile details</p>
                      </div>
                      <Form className="cmn-form-set" onSubmit={formik.handleSubmit}>
                        <Form.Group className="mb-3" controlId="formImage">
                          <Form.Label>Profile Image (Optional)</Form.Label>
                          <div className="cmpny-logo-upld">
                            {loading ?
                              <span className="dot">
                                <Spinner as="span" animation="border" variant="primary" size="sm" role="status" aria-hidden="true" />
                              </span>

                              :
                              <>
                                {uploadedUrl ?
                                  <img
                                    src={uploadedUrl ? uploadedUrl : require("../assets/images/vector-logo.svg").default}
                                    alt="Company Logo"
                                    style={{ width: "100px", height: "100px" }}
                                  /> :

                                  <img
                                    src={formik.values?.image ? formik?.values?.image : require("../assets/images/vector-logo.svg").default}
                                    alt="Company Logo"
                                    style={{ width: "100px", height: "100px" }}
                                  />
                                }

                              </>
                            }
                            <div>
                              <div className="cmpny-logo-upld">
                                <Form.Control
                                  type="file"
                                  name="image"
                                  accept="image/*"
                                  onChange={async (event) => {
                                    const file = event.target.files[0];
                                    if (file) {
                                      await uploadImage(file); // Wait for image upload
                                      formik.setFieldValue("image", uploadedUrl); // Set the uploaded image URL
                                    }
                                  }}
                                />
                                <button className="white-btn" disabled={loading}>
                                  Upload Photo
                                </button>
                              </div>
                              <Form.Text className="text-muted">
                                500 x 500 recommended
                              </Form.Text>
                            </div>
                          </div>
                        </Form.Group>

                        <Row>
                          <Col lg={12}>
                            <Form.Group className="mb-3" controlId="formname">
                              <Form.Label>Name</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Type here"
                                name="name"
                                value={formik.values.name}
                                // onChange={formik.handleChange}
                                onChange={(e) => {
                                  let value = e.target.value.replace(/^\s+/, ""); // Remove leading spaces
                                  value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                  formik.setFieldValue("name", value);
                                }}
                                onBlur={formik.handleBlur}
                                isInvalid={formik.touched.name && formik.errors.name}
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.errors.name}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>

                        <hr className="w-50 mx-auto mt-4 mb-4" />
                        <div className="form-box-title">
                          <h4>Location</h4>
                          <p>Your address</p>
                        </div>

                        <Form.Group className="mb-3" controlId="formPostCode">
                          <Form.Label>Post Code</Form.Label>
                          <div className="input-w-button">
                            <Form.Control
                              type="text"
                              name="postCode"
                              className="form-control"
                              placeholder="Type here"
                              value={formik.values.postCode}
                              onChange={(e) => {
                                const upperCaseValue = e.target.value.toUpperCase();
                                formik.setFieldValue("postCode", upperCaseValue);
                              }}
                              onBlur={formik.handleBlur}
                              isInvalid={formik.touched.postCode && formik.errors.postCode} // Ensure correct condition
                            />
                            <Button
                              variant="primary"
                              className="modal-f-btn pop-cancel-btn"
                              onClick={() => handleSearchClick(formik.values.postCode)}
                            >
                              Search
                            </Button>
                          </div>
                          {formik.touched.postCode && formik.errors.postCode && (
                            <div className="text-danger">{formik.errors.postCode}</div>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formAddress">
                          <Form.Label>Location Shown on Profile</Form.Label>
                          <Form.Control
                            as="select"
                            name="address"
                            className="form-select"
                            value={formik.values.address} // Ensure this is correctly bound to Formik's values
                            onChange={formik.handleChange} // Handle change with Formik's helper function
                          >
                            <option value="">Select Address</option>
                            {addressData?.addresses?.map((item, index) => (
                              <option
                                key={index}
                                value={item?.formatted_address
                                  ?.filter(item => item.trim() !== '')
                                  .map(item => item.split(',').map(word => word.trim()).join(','))
                                }
                              >
                                {item?.formatted_address
                                  ?.filter(item => item !== "")
                                  .join(", ")}
                              </option>
                            ))}
                          </Form.Control>

                          {formik.touched.address && formik.errors.address && (
                            <div className="text-danger">{formik.errors.address}</div>
                          )}
                        </Form.Group>


                        <hr className="w-50 mx-auto mt-4 mb-4" />
                        <div className="form-box-title">
                          <h4>Contact</h4>
                          <p>Your contact details and preferences</p>
                        </div>

                        <Row>
                          <Col lg={6}>
                            <Form.Group className="mb-3" controlId="formphoneNumber">
                              <Form.Label>Phone Number</Form.Label>
                              <PhoneInput
                                className="w-100"
                                country={"gb"}
                                name="phoneNumber"
                                enableSearch={true}
                                value={formik?.values.phoneNumber ? `+${formik?.values.countryCode}${formik?.values.phoneNumber}` : phone}
                                onChange={(phone, country) => {
                                  setPhone(phone);
                                  if (phone) {
                                    formik.setFieldValue("phoneNumber", phone.slice(country.dialCode.length))
                                    formik.setFieldValue('countryCode', country.dialCode);
                                  }


                                }}
                                onBlur={formik.handleBlur} // Ensure blur event is handled
                              />
                              {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                                <div className="text-danger">{formik.errors.phoneNumber}</div>
                              )}

                            </Form.Group>
                          </Col>
                          <Col lg={6}>
                            <Form.Group className="mb-3" controlId="formEmail">
                              <Form.Label>Email</Form.Label>
                              <Form.Control
                                type="email"
                                placeholder="Type here"
                                name="email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={formik.touched.email && formik.errors.email}
                              />
                              {formik.touched.email && formik.errors.email && (
                                <div className="text-danger">{formik.errors.email}</div>
                              )}
                            </Form.Group>
                          </Col>
                        </Row>

                        <div className="contact-preferences">
                          <h5>
                            I want to receive notifications when an electrician responds to my enquiry
                          </h5>
                          <ul>
                            <li>
                              <p>Email notifications</p>
                              <Form.Check
                                type="switch"
                                className="custom-switch"
                                name="electrianRespond.emailNotification"
                                checked={formik.values.electrianRespond.emailNotification}
                                onChange={formik.handleChange}
                              />
                            </li>

                          </ul>
                        </div>

                        {/* <div className="contact-preferences">
                          <h5>I want to receive marketing from SparkPro</h5>
                          <ul>
                            <li>
                              <p>Email notifications</p>
                              <Form.Check
                                type="switch"
                                className="custom-switch"
                                name="marketingSparkPro.emailNotification"
                                checked={formik.values.marketingSparkPro.emailNotification}
                                onChange={formik.handleChange}
                              />
                            </li>

                          </ul>
                        </div> */}

                        <div className="d-flex gap-4 mt-4">
                          <button type="submit" className="theme-comm-btn">
                            Save
                          </button>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>


                <CustomerUpdatePassword/>

                <div className="my-profile-box-form">
                  <div className="form-box-title">
                    <h4>Looking to Leave?</h4>
                    <p>Request to delete your account from here.</p>
                  </div>
                  <div className="h-100 m-0">
                    <div className="d-flex gap-4">
                      <button className="theme-red-comm-btn"
                        // onClick={() => handleDelete("customerDelete")}
                        onClick={() => handlePasswordConfirm("customerDelete")}
                      >
                        Delete Account
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={4}></Col>
          </Row>
        </div>
      </Container>
      <EmailverifyModal
        show={show}
        handleClose={handleClose}
        refresh={refresh}
        updatedEmail={updatedEmail}
      />

      <ConfirmModal
        data={location.search}
        isModalOpen={isModalOpen}
        selectedType={selectedType}
        handleConfirmClose={handleConfirmClose}
      />
      <ConfirmPassword
      passwordshow={passwordshow}
      handlePasswordClose={handlePasswordClose}
      handleDelete={handleDelete}
      type={"customerDelete"}
      />
    </Layout>
  );
}
